import { CourseInDto } from "../../types/course.dto";
import { useTheme } from "styled-components";
import { Card } from "./styles";
import { Flex } from "../StyledComponents";

import Progress from "./components/Progress";
import Valoration from "../Valoration";
import Continue from "./components/Continue";

import Typography from "../Typography";
import Icon from "../Icon";

import InformationCircleIcon from "../../assets/icons/icon-cool/filled/InformationCircle.svg";
import CourseImage from "../CourseImage";
import { useMemo } from "react";

interface ComponentProps {
  course: CourseInDto;
}

const Component = ({ course }: ComponentProps) => {
  const theme = useTheme() as { [key: string]: { [key: string]: string } };

  const url = useMemo(() => {
    const hasUserFeedback = !!course?.labEnrollment?.[0]?.labFeedback;
    const isFinished = course?.labEnrollment?.[0]?.state === "Finished";
    const idCourse = course?.id;
    const idUnit = course?.labEnrollment[0]?.last_unit_id;
    const idComponent = course?.labEnrollment[0]?.last_component_id;
    return isFinished
      ? hasUserFeedback
        ? `/dashboard/mis-cursos/${idCourse}/finished`
        : `/dashboard/mis-cursos/${idCourse}/valoration`
      : `/dashboard/mis-cursos/${idCourse}/${idUnit}/${idComponent}`
  }, [course]);

  return (
    <Card to={url} >
      <Flex gap={16} justify="space-between">
        <CourseImage courseId={course.id} imageId={course.image_id || null} />
        <Flex gap={8} column>
          <Flex justify="space-between" style={{ minHeight: 39 }}>
            <Typography as="h5" size="sm">
              {course?.title}
            </Typography>

            <Flex width={37} justify="flex-end">
              <Progress
                shape="ring"
                current={course?.labEnrollment?.[0].components_completed}
                total={course?.total_components}
                showNumber
              />
            </Flex>
          </Flex>

          <Flex align="center" gap={5} style={{ height: 14 }}>
            {course.enrollment_requirement === "Mandatory" && (
              <>
                <Typography as="p" size="xs">
                  Obligatorio
                </Typography>
                <Icon
                  icon={InformationCircleIcon}
                  size="12px"
                  color={theme.colors.Warning}
                />
              </>
            )}

            {course.enrollment_requirement === "Optional" && (
              <Typography as="p" size="xs">
                Optativo
              </Typography>
            )}
          </Flex>

          <Flex gap={5}>
            <Flex column gap={3}>
              <Flex justify="space-between" aligne="center">
                <Flex gap={5}>
                  <Typography as="p" size="xs">
                    {course?.labEnrollment?.[0].components_completed}/
                    {course?.total_components}
                  </Typography>
                  {course?.labEnrollment[0]?.state === "Finished" && (
                    <Typography as="p" size="xs">
                      Finalizado
                    </Typography>
                  )}
                </Flex>
                {course?.labEnrollment[0]?.state === "Finished" && (
                  <Valoration value={course?.avg_rating} />
                )}
              </Flex>

              <Progress
                shape="bar"
                current={course?.labEnrollment?.[0].components_completed}
                total={course?.total_components}
              />
            </Flex>

            {/* <Save />
             */}
            <Continue />
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
};

export default Component;
